import styled from 'styled-components';

const percentage = 0.1;

export function decrease(number) {
  return number - number * percentage;
}

export const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 0px;
  overflow-y: hidden;
`;

export const Content = styled.div`
  width: ${(props) => (props.decrease ? decrease(180) : 180)}px;
  height: ${(props) => (props.decrease ? decrease(425) : 425)}px;
  position: relative;
`;

export const Image = styled.img`
  max-height: 100%;
  object-fit: contain;
`;

export const TouchArea = styled.div`
  position: absolute;
  width: ${(props) => (props.decrease ? decrease(26) : 26)}px;
  height: ${(props) => (props.decrease ? decrease(26) : 26)}px;
  border-radius: ${(props) => (props.decrease ? decrease(13) : 13)}px;
  border-width: ${(props) => (props.decrease ? decrease(4.5) : 4.5)}px;
  border-color: ${(props) => (props.active ? '#CC2954' : '#cce6ee')};
  border-style: solid;
`;

// Cabeça
export const Head = styled(TouchArea)`
  top: -${(props) => (props.decrease ? decrease(6) : 6)}px;
  width: ${(props) => (props.decrease ? decrease(44) : 44)}px;
  height: ${(props) => (props.decrease ? decrease(16) : 16)}px;
  border-radius: ${(props) => (props.decrease ? decrease(10) : 10)}px;
  right: 0;
  left: 0;
  margin: auto;
`;

// Boca
export const Mouth = styled(TouchArea)`
  top: ${(props) => (props.decrease ? decrease(38) : 38)}px;
  right: 0;
  left: 0;
  margin: auto;
`;

// Ombro esquerdo
export const LeftShoulder = styled(TouchArea)`
  left: ${(props) => (props.decrease ? decrease(24) : 24)}px;
  top: ${(props) => (props.decrease ? decrease(72) : 72)}px;
`;

// Ombro direito
export const RightShoulder = styled(TouchArea)`
  right: ${(props) => (props.decrease ? decrease(24) : 24)}px;
  top: ${(props) => (props.decrease ? decrease(72) : 72)}px;
`;

// Abdômen
export const Abdomen = styled(TouchArea)`
  top: ${(props) => (props.decrease ? decrease(125) : 125)}px;
  right: 0;
  left: 0;
  margin: auto;
`;

// Pulso esquerdo
export const LeftPulse = styled(TouchArea)`
  left: ${(props) => (props.decrease ? decrease(11) : 11)}px;
  top: ${(props) => (props.decrease ? decrease(192) : 192)}px;
`;

// Pulso direito
export const RightPulse = styled(TouchArea)`
  right: ${(props) => (props.decrease ? decrease(11) : 11)}px;
  top: ${(props) => (props.decrease ? decrease(192) : 192)}px;
`;

// Virilha esquerda
export const LeftGroin = styled(TouchArea)`
  left: ${(props) => (props.decrease ? decrease(62) : 62)}px;
  top: ${(props) => (props.decrease ? decrease(202) : 202)}px;
`;

// Virilha direita
export const RightGroin = styled(TouchArea)`
  right: ${(props) => (props.decrease ? decrease(62) : 62)}px;
  top: ${(props) => (props.decrease ? decrease(202) : 202)}px;
`;

// Coxa esquerda
export const LeftThigh = styled(TouchArea)`
  left: ${(props) => (props.decrease ? decrease(58) : 58)}px;
  top: ${(props) => (props.decrease ? decrease(248) : 248)}px;
`;

// Coxa direita
export const RightThigh = styled(TouchArea)`
  right: ${(props) => (props.decrease ? decrease(58) : 58)}px;
  top: ${(props) => (props.decrease ? decrease(248) : 248)}px;
`;

// Joelho esquerdo
export const LeftKnee = styled(TouchArea)`
  left: ${(props) => (props.decrease ? decrease(62) : 62)}px;
  top: ${(props) => (props.decrease ? decrease(291) : 291)}px;
`;

// Joelho direito
export const RightKnee = styled(TouchArea)`
  right: ${(props) => (props.decrease ? decrease(62) : 62)}px;
  top: ${(props) => (props.decrease ? decrease(291) : 291)}px;
`;
